import { motion } from 'framer-motion';
import { Shield, Lock, Award } from 'lucide-react';

const SocialProofBar = () => {
  /* Logos de clínicas parceiras — substitua pelos logos reais quando disponíveis */
  const partnerClinics = [
    'Clínica Revalidatie',
    'FisioVida',
    'Centro Reabilitar',
    'Clínica Movimento',
    'Respire Fisioterapia',
    'CardioFisio',
  ];

  return (
    <section className="relative py-12 bg-slate-950 border-y border-white/5">
      <div className="container mx-auto px-4">
        {/* Título */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center text-sm font-medium text-slate-500 uppercase tracking-widest mb-8"
        >
          Clínicas que confiam no RevaHub
        </motion.p>

        {/* Logos das clínicas */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex flex-wrap items-center justify-center gap-8 md:gap-12 mb-10"
        >
          {partnerClinics.map((clinic) => (
            <div
              key={clinic}
              className="flex items-center gap-2 text-slate-500 hover:text-slate-300 transition-colors duration-300"
            >
              <div className="h-8 w-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
                <span className="text-xs font-bold text-slate-400">
                  {clinic
                    .split(' ')
                    .map((w) => w[0])
                    .join('')
                    .slice(0, 2)}
                </span>
              </div>
              <span className="text-sm font-medium hidden sm:inline">{clinic}</span>
            </div>
          ))}
        </motion.div>

        {/* Selos de confiança */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap items-center justify-center gap-6 md:gap-10"
        >
          {[
            { icon: Shield, label: 'LGPD Compliant' },
            { icon: Award, label: 'COFFITO 414/2012' },
            { icon: Lock, label: 'Dados Criptografados' },
          ].map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex items-center gap-2 text-slate-500"
            >
              <Icon size={16} className="text-cyan-500/70" />
              <span className="text-xs font-medium tracking-wide">{label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProofBar;
